import React, { PropsWithChildren, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { DNABox, DNAButton, Hoverable, Iffy, luxColors } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  overlay: {
    alignItems: 'center',
    backgroundColor: luxColors.opacityBackground.primary,
    height: '100%',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
    borderColor: colors['color-ui2-neutral-700'],
    borderRadius: 6,
    borderWidth: 4,
    pointerEvents: 'none',
  },
  presentButton: {
    alignItems: 'center',
    backgroundColor: luxColors.thumbnailBorder.primary,
    borderRadius: 50,
    height: 45,
    justifyContent: 'center',
    paddingLeft: 15,
    paddingRight: 15,
    width: 100,
  },
  presentText: {
    color: luxColors.tag.primary,
    fontSize: 15,
    fontWeight: 'bold',
  },
});

interface Props {
  bypassWrapper?: boolean;
  itemHeight: number;
  onPresent?: () => void;
  onPreview?: () => void;
  showPresent?: boolean;
  showPreview: boolean;
}

const Wrapper: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children, itemHeight, onPresent, onPreview, showPresent = true, showPreview } = props;
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const showOverlay = isHovered && (showPresent || showPreview);

  function toggleHover(): void {
    setIsHovered(!isHovered);
  }

  if (props.bypassWrapper) {
    return <>{children}</>;
  }

  return (
    <Hoverable onHoverIn={toggleHover} onHoverOut={toggleHover}>
      <View>
        {children}
        <Iffy is={showOverlay}>
          <DNABox spacing="sm" appearance="col" style={[styles.overlay, { height: itemHeight + 4 }]}>
            <Iffy is={showPresent}>
              <DNABox style={{ pointerEvents: 'auto' }}>
                <DNAButton
                  testID="meeting-present-button"
                  iconLeft="play-fill"
                  onPress={onPresent}
                  children="Present"
                />
              </DNABox>
            </Iffy>
            <Iffy is={!!showPreview}>
              <DNABox style={{ pointerEvents: 'auto' }}>
                <DNAButton
                  status="tertiary"
                  iconLeft="eye"
                  onPress={onPreview}
                  children="Preview"
                />
              </DNABox>
            </Iffy>
          </DNABox>
        </Iffy>
      </View>
    </Hoverable>
  );
};

export default Wrapper;
